import { Component, OnDestroy, OnInit } from '@angular/core';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { map, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { VisaDesignerService } from '../visa-designer.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { IMMIGRANT_FORMS } from 'app-models';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import * as vdTask from './../vd-state/actions/vd.actions';
import { E } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-vd-visa-creation',
  templateUrl: './vd-visa-creation.component.html',
  styleUrls: ['./vd-visa-creation.component.scss']
})
export class VdVisaCreationComponent implements OnInit, OnDestroy {
  visaCreateForm: FormGroup;
  observableSubscription$ = new Subject();
  listCountry = [];
  languageArr: {
    createdBy: number; modifiedBy: any; id: number; group: string;
    refGroupdesc: string; code: string; name: string; description: string;
  }[] = [];
  formTypeArr: {
    createdBy: number; modifiedBy: any; id: number; group: string; refGroupdesc: string;
    code: string; name: string; description: string;
  }[] = [];
  visaTypeArr: {
    createdBy: number; modifiedBy: any; id: number; group: string; refGroupdesc: string;
    code: string; name: string; description: string;
  }[] = [];
  subTaskTypeArr: {
    createdBy: number; modifiedBy: any; id: number; group: string; refGroupdesc: string;
    code: string; name: string; description: string;
  }[] = [];
  petitionTypeArr: {
    createdBy: number; modifiedBy: any; id: number; group: string; refGroupdesc: string;
    code: string; name: string; description: string;
  }[] = [];
  initiateTaskPermissionArr = [];
  visaId: any;
  visaInfo: any;
  feeData = [];
  disabledControls = false;
  displayAddFeeTypePanel = false;
  newFeeType = {
    feeAmount: 0,
    name: '',
    maxEmpCount: null,
    minEmpCount: null,
    id: null
  };
  newlyAddedFeeTypeArr = [];
  showUpdateButton = false;
  visaAndPetitionTypeArr = [];
  showSubTaskTypeSection = false;
  serviceCenterList = [];
  publishedOn = '';
  showImmigrantSection = false;
  isDuplicate = false;
  buildType: string;
  isRepublish = false;
  isView = false;
  isEditVisa = false;

  constructor(
    private fb: FormBuilder,
    protected store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private vdService: VisaDesignerService,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService
  ) {


    this.visaCreateForm = new FormGroup({
      visaId: new FormControl(null),
      visaName: new FormControl(null, Validators.required),
      countryCode: new FormControl(null, Validators.required),
      language: new FormControl(null, Validators.required),
      formType: new FormControl(null, Validators.required),
      visaType: new FormControl(null),
      petitionType: new FormControl(null),
      immCategoryCode: new FormControl(null),
      immClassificationCode: new FormControl(null),
      subTaskType: new FormControl(null, Validators.required),
      initiateTask: new FormArray([]),
      //  serviceCenterJson: this.fb.array([], [Validators.required])
      serviceCenterJson: this.fb.array([])
    }, [
      this.visaTypeFieldRequired.bind(this),
      this.petitionTypeFieldRequired.bind(this),
      this.immCategoryCodeFieldRequired.bind(this),
      this.immClassificationCodeFieldRequired.bind(this),
      this.subTaskTypeCodeCodeFieldRequired.bind(this)
    ]);
  }

  visaTypeFieldRequired(group: FormGroup): { [s: string]: boolean } {
    // if (group.value.formType && !IMMIGRANT_FORMS.includes(group.value.formType) && !group.value.visaType) {
    //   return { visaTypeFieldIsRequired: true };
    // }
    if (group.value.formType && !this.showImmigrantSection && !group.value.visaType) {
      return { visaTypeFieldIsRequired: true };
    }
    return null;
  }

  petitionTypeFieldRequired(group: FormGroup): { [s: string]: boolean } {
    // if (group.value.formType && !IMMIGRANT_FORMS.includes(group.value.formType) && !group.value.petitionType) {
    //   return { petitionTypeFieldIsRequired: true };
    // }
    if (group.value.formType && !this.showImmigrantSection && !group.value.petitionType) {
      return { petitionTypeFieldIsRequired: true };
    }
    return null;
  }

  immCategoryCodeFieldRequired(group: FormGroup): { [s: string]: boolean } {
    // if (group.value.formType && IMMIGRANT_FORMS.includes(group.value.formType) && !group.value.immCategoryCode) {
    //   return { immCategoryCodeFieldIsRequired: true };
    // }
    if (group.value.formType && this.showImmigrantSection && !group.value.immCategoryCode) {
      return { immCategoryCodeFieldIsRequired: true };
    }
    return null;
  }

  immClassificationCodeFieldRequired(group: FormGroup): { [s: string]: boolean } {
    // if (group.value.formType && IMMIGRANT_FORMS.includes(group.value.formType) && !group.value.immClassificationCode) {
    //   return { immClassificationCodeFieldIsRequired: true };
    // }
    if (group.value.formType && this.showImmigrantSection && !group.value.immClassificationCode) {
      return { immClassificationCodeFieldIsRequired: true };
    }
    return null;
  }

  subTaskTypeCodeCodeFieldRequired(group: FormGroup): { [s: string]: boolean } {
    // if (group.value.formType && IMMIGRANT_FORMS.includes(group.value.formType) && !group.value.subTaskType) {
    //   return { subTaskTypeCodeCodeFieldIsRequired: true };
    // }
    if (group.value.formType && this.showImmigrantSection && !group.value.subTaskType) {
      return { subTaskTypeCodeCodeFieldIsRequired: true };
    }
    return null;
  }

  ngOnInit(): void {
    this.vdService.getCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.listCountry = response.data && response.data.length > 0 ? response.data : [];
    });

    this.initiateTaskPermissionArr = [
      { name: 'Petitioner', code: 'Petitioner', disabled: false, checked: true },
      { name: 'Attorney', code: 'Attorney', disabled: false, checked: true },
      { name: 'Beneficiary', code: 'Beneficiary', disabled: false, checked: false },
      { name: 'Guardian', code: 'Guardian', disabled: true, checked: false },
      { name: 'Sponsor', code: 'Sponsor', disabled: true, checked: false }
    ];
    this.addInitiateTaskPermissionArrFormControl();

    this.visaCreateForm.valueChanges.pipe(
      map(() => this.visaCreateForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
    this.route.params.subscribe((params) => {
      // console.log(params);
      this.visaId = params['id'] != 'new' ? params['id'] : null;
      localStorage.setItem('visaId', this.visaId);
      this.isDuplicate = (params['isDuplicate'] === 'duplicate') ? true : false;
      this.isView = (params['isDuplicate'] === 'view') ? true : false;
      //this.isDuplicate = (params['isDuplicate'] === 'duplicate') ? true : false;
      // this.isRepublish = (params['isDuplicate'] === 'republish') ? true : false;
      if (this.visaId) {
        this.getVisaInfo(this.visaId);
      } else {
        this.store.select(fromVDTask.getVDBuildType).pipe(take(1)).subscribe(formVDState => {
          switch (formVDState) {
            case 'pdf':
              this.buildType = 'PDFTOWF';
              break;
            case 'build':
            case 'old':
              this.buildType = 'NORMAL';
              break;
            default:
              this.router.navigate(['../../../manage-visa/created-visas'], { relativeTo: this.route });
              break;
          }
        });
      }
    });
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
    // this.getFeesMasterData();
  }

  handleCountryChange(countryCode?) {
    if (!countryCode) {
      countryCode = this.visaCreateForm.get('countryCode').value;
    }
    // const countryCode = 'USA';
    this.vdService.getLanguageAndFormType(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.languageArr = response.data && response.data.language && response.data.language.length > 0 ? response.data.language : [];
      this.formTypeArr = response.data && response.data.formType && response.data.formType.length > 0 ? response.data.formType : [];
    });
  }

  handleSubTaskChange() {
    this.getServiceCenterList();
    this.getFeesMasterData();

  }

  disableFormControl() {
    if (this.visaCreateForm) {
      Object.keys(this.visaCreateForm.controls).forEach((key) => {
        if (this.publishedOn) {
          this.visaCreateForm.controls[key].disable();
        } else {
          if (!['visaId', 'visaName', 'serviceCenterJson'].includes(key)) {
            this.visaCreateForm.controls[key].disable();
          }
        }

      });
    }
  }

  getVisaInfo(visaId) {
    this.vdService.getVisaById(visaId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.visaInfo = response.data ? response.data : null;
      this.publishedOn = this.visaInfo?.publishedOn || this.visaInfo?.previousPublishedOn || '';
      if (this.visaInfo) {
        this.isRepublish = (this.publishedOn && !this.isDuplicate) ? true : false;
        this.store.dispatch(new vdTask.SetVDBuildType(
          this.visaInfo.formCreationType && this.visaInfo.formCreationType.code ?
            (this.visaInfo.formCreationType.code === 'PDFTOWF' ?
              'pdf' : 'build') : 'old'));
        this.buildType = this.visaInfo.formCreationType && this.visaInfo.formCreationType.code ? this.visaInfo.formCreationType.code : null;
        //if (!this.isDuplicate && !this.isRepublish) {
        if (!this.isDuplicate) {
          this.disableFormControl();
        } else {
          if (this.isDuplicate) {
            this.visaInfo.visaName = '';
          }

        }
        this.visaInfo.feeJson = this.visaInfo.feeJson ? JSON.parse(this.visaInfo.feeJson) : [];
        this.visaInfo.serviceCenterJson = this.visaInfo.serviceCenterJson ? JSON.parse(this.visaInfo.serviceCenterJson) : [];
        // this.showImmigrantSection = IMMIGRANT_FORMS.includes(this.visaInfo.formType.code);
        this.handleCountryChange(this.visaInfo.country.countryCode);
        this.handleChange(this.visaInfo.country.countryCode, this.visaInfo.formType.code);
        this.handlePetitionTypeChange();
        this.patchTheFormData();

        if (this.visaInfo.feeJson && this.visaInfo.feeJson.length > 0) {
          const feeJson = this.visaInfo.feeJson;
          // feeJson  = this.visaInfo.feeJson ?  JSON.parse(this.visaInfo.feeJson):[];
          this.feeData = feeJson.filter(item => item.id);
          this.newlyAddedFeeTypeArr = feeJson.filter(item => !item.id);

        } else {
          this.getFeesMasterData();
        }

      }

      // console.log("$$$$$ this.isRepublish",this.isRepublish)

    });
  }

  getFeesMasterData(type?) {

    const subTaskType = this.visaCreateForm.get('subTaskType').value;
    // const subTaskType = "I485";
    const payload = {
      petitionType: this.showImmigrantSection ? null : this.visaCreateForm.get('petitionType').value,
      visaType: this.showImmigrantSection ? null : this.visaCreateForm.get('visaType').value,
      immCategory: this.showImmigrantSection ? this.visaCreateForm.get('immCategoryCode').value : null,
      immClassification: this.showImmigrantSection ? this.visaCreateForm.get('immClassificationCode').value : null,

    };
    this.vdService.getFeeMasterData(subTaskType, payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      if (type === 'RESET' && response.status === 200) {
        this.toastr.success('Data Reset Successfully', 'Success');
      }
      this.feeData = response && response.data ? response.data : [];


    });
  }

  getServiceCenterList() {
    let payload;

    payload = {
      petitionType: this.showImmigrantSection ? null : this.visaCreateForm.get('petitionType').value,
      visaType: this.showImmigrantSection ? null : this.visaCreateForm.get('visaType').value,
      countryCode: this.visaCreateForm.get('countryCode').value,
      subTaskType: this.visaCreateForm.get('subTaskType').value,
      // "subTaskType":"I485",
      immCategory: this.showImmigrantSection ? this.visaCreateForm.get('immCategoryCode').value : null,
      immClassification: this.showImmigrantSection ? this.visaCreateForm.get('immClassificationCode').value : null,
    };

    if (payload.subTaskType) {
      this.vdService.getServiceCenterList(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        this.serviceCenterList = response && response.data ? response.data : [];
        if (this.serviceCenterList.length > 0) {
          this.addServiceCenterFormControl();
        }
      });
    }
  }


  patchTheFormData() {
    this.visaCreateForm.patchValue({
      visaId: this.visaInfo.visaId ? this.visaInfo.visaId : 0,
      visaName: this.visaInfo.visaName ? this.visaInfo.visaName : '',
      countryCode: this.visaInfo.country && this.visaInfo.country.countryCode ? this.visaInfo.country.countryCode : '',
      language: this.visaInfo.language && this.visaInfo.language.code ? this.visaInfo.language.code : '',
      formType: this.visaInfo.formType && this.visaInfo.formType.code ? this.visaInfo.formType.code : '',
      visaType: this.visaInfo.visaType && this.visaInfo.visaType.code ? this.visaInfo.visaType.code : '',
      petitionType: this.visaInfo.petitionType && this.visaInfo.petitionType.code ? this.visaInfo.petitionType.code : '',
      immCategoryCode: this.visaInfo.immCategory && this.visaInfo.immCategory.code ? this.visaInfo.immCategory.code : '',
      immClassificationCode: this.visaInfo.immClassification &&
        this.visaInfo.immClassification.code ? this.visaInfo.immClassification.code : '',
      subTaskType: this.visaInfo.subTaskType && this.visaInfo.subTaskType.code ? this.visaInfo.subTaskType.code : '',

    });
    this.showImmigrantSection = this.visaInfo.visaId && this.visaInfo.visaType ? false:true; 

    this.handlePetitionTypeChange();
    this.getServiceCenterList();
  }




  handleChange(countryCode?, formType?) {
    this.visaTypeArr = [];
    this.petitionTypeArr = [];
    this.subTaskTypeArr = [];
    this.visaCreateForm.patchValue({
      visaType: null,
      petitionType: null,
      immCategoryCode: null,
      immClassificationCode: null,
      subTaskType: null
    });
    if (!this.visaId || this.isDuplicate || this.isRepublish) {
      countryCode = (countryCode) ? countryCode : this.visaCreateForm.get('countryCode').value;
      formType = (formType) ? formType : this.visaCreateForm.get('formType').value;
    }
    //  this.showImmigrantSection = IMMIGRANT_FORMS.includes(formType);
    // this.addDynamicValidation();


    if (countryCode && formType) {
      const payload = {
        countryCode,
        formType
      };
      this.vdService.getAllDependentDataByFormType(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        this.showImmigrantSection = response?.data?.visaAndPetitionType && response.data.visaAndPetitionType.length > 0 ? false : true;
        if (response.data && (response.data.visaAndPetitionType || (response.data.allVisaAndPetitionType && response.data.allVisaAndPetitionType.length > 0))) {

          this.visaAndPetitionTypeArr = this.visaId ? response.data.allVisaAndPetitionType : response.data.visaAndPetitionType;
          this.visaTypeArr = this.visaAndPetitionTypeArr.map(x => x.visaType);
          if (this.visaId && this.visaAndPetitionTypeArr && this.visaAndPetitionTypeArr.length > 0) {
            this.handleVisaTyepeChange();
          }
        } else if (response.data && this.showImmigrantSection && (response.data.immigratioCatAndClassType || response.data.allImmigratioCatAndClassType)) {
          this.visaAndPetitionTypeArr = this.visaId ? response.data.allImmigratioCatAndClassType : response.data.immigratioCatAndClassType;
          // this.visaAndPetitionTypeArr = response.data.allImmigratioCatAndClassType;
          this.visaTypeArr = this.visaAndPetitionTypeArr.map(x => x.immigrationCategory);
          if (this.visaId && this.visaAndPetitionTypeArr && this.visaAndPetitionTypeArr.length > 0) {
            this.handleVisaTyepeChange();
          }
        }
        this.subTaskTypeArr = response.data && response.data.subTaskType &&
          response.data.subTaskType.length > 0 ? response.data.subTaskType : [];
        const isRFE = this.subTaskTypeArr.findIndex(x => x.code === 'RFE');
        if (isRFE >= 0) {
          this.subTaskTypeArr.splice(isRFE, 1);
        }

        // this.visaTypeArr = response.data && response.data.visaAndPetitionType
        //  this.petitionTypeArr = response.data && response.data.petitionType && response.data.petitionType.length > 0 ? response.data.petitionType : [];

      });
    }
  }

  // addDynamicValidation() {
  //   if (this.showImmigrantSection) {
  //     this.visaCreateForm.get('visaType').clearValidators();
  //     this.visaCreateForm.get('petitionType').clearValidators();
  //     this.visaCreateForm.get('immCategoryCode').setValidators([Validators.required]);
  //     this.visaCreateForm.get('immClassificationCode').setValidators([Validators.required]);
  //   } else {
  //     // this.visaCreateForm.get('immClassificationCode').reset();
  //     this.visaCreateForm.get('immCategoryCode').clearValidators();
  //     this.visaCreateForm.get('immClassificationCode').clearValidators();
  //     this.visaCreateForm.get('visaType').setValidators([Validators.required]);
  //     this.visaCreateForm.get('petitionType').setValidators([Validators.required]);
  //   }
  //   this.visaCreateForm.updateValueAndValidity();
  // }

  addInitiateTaskPermissionArrFormControl() {
    const initiateArray = this.visaCreateForm.get('initiateTask') as FormArray;
    initiateArray.clear();
    if (this.initiateTaskPermissionArr && this.initiateTaskPermissionArr.length > 0) {
      this.initiateTaskPermissionArr.forEach((x, index) => {
        // const isChecked = false;
        initiateArray.push(new FormControl(x.checked));
      });
    }
  }

  addServiceCenterFormControl() {
    const initiateArray = this.visaCreateForm.get('serviceCenterJson') as FormArray;

    let isChecked;
    initiateArray.clear();
    if (this.serviceCenterList && this.serviceCenterList.length > 0) {
      this.serviceCenterList.forEach((x, index) => {
        if (this.visaId) {
          isChecked = this.visaInfo.serviceCenterJson &&
            this.visaInfo.serviceCenterJson.length > 0 &&
            this.visaInfo.serviceCenterJson.some(y => y.centerName === x.centerName);
        } else {
          isChecked = false;
        }

        initiateArray.push(new FormControl(isChecked));
      });

      // initiateArray,)
    }
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }
  createNewVisa() {
    const initiateTask = [];
    const serviceCenterJson = [];
    if (this.visaCreateForm.value.initiateTask && this.visaCreateForm.value.initiateTask.length > 0) {
      this.visaCreateForm.value.initiateTask.forEach((isSelected, i) => {
        if (isSelected) {
          const raceObj = this.initiateTaskPermissionArr[i];
          initiateTask.push({
            ...raceObj
          });
        }
      });
    }

    if (this.visaCreateForm.value.serviceCenterJson && this.visaCreateForm.value.serviceCenterJson.length > 0) {
      this.visaCreateForm.value.serviceCenterJson.forEach((isSelected, i) => {
        if (isSelected) {
          const item = this.serviceCenterList[i];
          serviceCenterJson.push({
            ...item
          });
        }
      });

    }

    const feeJson = this.feeData.concat(this.newlyAddedFeeTypeArr);
    let payload = {
      ... this.visaCreateForm.getRawValue(),
      initiateTask,
      serviceCenterJson: JSON.stringify(serviceCenterJson),
      feeJson: JSON.stringify(feeJson)
    };
    // console.log(payload);
    // console.log(this.isDuplicate);
    // console.log(this.isRepublish);
    // if (this.visaId) {
    //   this.router.navigate([`../../visa-details-steps/${this.visaId}`], { relativeTo: this.route });
    // } else {
    if (!this.isDuplicate && !this.isRepublish) { //create new
      payload = {
        ...payload,
        formCreationType: this.buildType //? this.buildType : 'old',
      }
      //check for duplicate visa name
      if (!payload.visaId) {
        this.vdService.checkDuplicateVisaName(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
          if (response && response.status === 200) {
            this.saveVisa(payload);
          }
        });
      } else {
        this.saveVisa(payload);
      }
    } else if (this.isRepublish) { // Republish
      payload = {
        ...payload,
        formCreationType: this.buildType //? this.buildType : 'old',
      }
      // console.log(payload);
      this.confirmationService.confirm({
        message: 'Do you want to create a version of this template and Republish?',
        header: 'Confirm',
        key: 'confirmVersioning',
        accept: () => {
          this.vdService.rePublishVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
            if (response && response.status === 200) {
              this.toastr.success(response.message, 'Success');
              this.resetForm();
              if (response.data) {
                localStorage.setItem('visaId', response.data);
                localStorage.setItem('isEditVisa', 'true');
                this.router.navigate([`../../visa-details-steps/${response.data}`], { relativeTo: this.route });
                // this.router.navigate([`../../../visa-details-steps/${response.data}`], { relativeTo: this.route });
              }
    
            }
          });
        },
        reject: () => {
          localStorage.setItem('isEditVisa', 'true');
          this.onNext();
        }
      });      
    } else if (this.isDuplicate) {
      const type = this.isDuplicate ? 'duplicate' : this.isRepublish ? 'republish' : '';
      payload = {
        ...payload,
        formCreationType: this.buildType//this.buildType ? this.buildType : 'old',
      }
      // this.vdService.checkDuplicateVisaName(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      //if (response && response.status === 200) {
      this.vdService.duplicateVisa(payload, type).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        if (response && response.status === 200) {
          this.toastr.success(response.message, 'Success');
          this.resetForm();
          if (response.data) {
            localStorage.setItem('visaId', response.data);
            this.router.navigate([`../../../visa-details-steps/${response.data}`], { relativeTo: this.route });
            //this.router.navigate([`../../../visa-details-steps/${response.data}`], { relativeTo: this.route });
          }
        }
      });
      //}
      //});

    }


    // }


    // this.router.navigate(['../../visa-details-steps/1'],{ relativeTo: this.route});
  }

  saveVisa(payload) {
    if (this.visaId) {
      this.confirmationService.confirm({
        message: 'Do you want to create a version of this template and Republish?',
        header: 'Confirm',
        key: 'confirmVersioning',
        accept: () => {         
          this.vdService.createVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
            if (response && response.status === 200) {
              this.toastr.success(response.message, 'Success');
              this.resetForm();
              if (response.data) {
                localStorage.setItem('visaId', response.data);
                localStorage.setItem('isEditVisa', 'true');
                this.router.navigate([`../../visa-details-steps/${response.data}`], { relativeTo: this.route });
              }

            }
          });
        },
        reject: () => {
          localStorage.setItem('isEditVisa', 'true');
          this.onNext();
        }
      });
    } else {
      this.vdService.createVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        if (response && response.status === 200) {
          this.toastr.success(response.message, 'Success');
          this.resetForm();
          if (response.data) {
            localStorage.setItem('visaId', response.data);
            localStorage.setItem('isEditVisa', 'true');
            this.router.navigate([`../../visa-details-steps/${response.data}`], { relativeTo: this.route });
          }

        }
      });
    }

  }

  hadleCancel() {
    this.resetForm();
    this.goBackToList();
  }

  onNext() {
    // console.log(this.visaId);
    if (this.isView) {
      this.router.navigate([`../../../visa-details-steps/${this.visaId}/view`], { relativeTo: this.route });
    } else {
      this.router.navigate([`../../visa-details-steps/${this.visaId}`], { relativeTo: this.route });
    }

  }

  handleVisaTyepeChange() {
    // if(!this.visaId){
    if (this.showImmigrantSection) {
      if (!this.visaId || this.isDuplicate) {
        this.visaCreateForm.get('immClassificationCode').reset();
      }

      const immCategoryCode = this.visaCreateForm.get('immCategoryCode').value;
      const tempArr = this.visaAndPetitionTypeArr.find(item => item.immigrationCategory.code === immCategoryCode);
      this.petitionTypeArr = tempArr ? tempArr.immigrationClassType : [];

    } else {
      if (!this.visaId || this.isDuplicate) {
        this.visaCreateForm.get('petitionType').reset();
      }
      if (this.visaCreateForm.get('visaType') && this.visaCreateForm.get('visaType').value) {
        const visaType = this.visaCreateForm.get('visaType').value;
        const tempArr = this.visaAndPetitionTypeArr.find(item => item.visaType.code === visaType);
        this.petitionTypeArr = tempArr ? tempArr.petitionType : [];
      } else {
        this.petitionTypeArr = [];
      }
    }

    if (!this.visaId || this.isDuplicate) {
      this.visaCreateForm.get('subTaskType').reset();
    } else {
      this.handlePetitionTypeChange();
    }


    // }


  }
  handlePetitionTypeChange() {
    this.showSubTaskTypeSection = true;
    if (!this.visaId || this.isDuplicate) {
      this.visaCreateForm.get('subTaskType').reset();
    }
  }
  resetForm() {
    this.visaCreateForm.reset();
  }
  addNewFeeType() {
    this.showUpdateButton = false;
    this.resetFeeType();
    this.displayAddFeeTypePanel = true;
  }
  handleResetFee() {
    this.getFeesMasterData('RESET');
  }
  resetFeeType() {
    this.newFeeType = {
      feeAmount: 0,
      name: '',
      maxEmpCount: null,
      minEmpCount: null,
      id: null

    };

  }
  saveNewFeeType(type) {
    const newFeeObj = {
      applicableFee: this.newFeeType.feeAmount,
      feeType: { name: this.newFeeType.name },
      id: this.newFeeType.id ? this.newFeeType.id : null,
      maxEmpCount: this.newFeeType.maxEmpCount ? this.newFeeType.maxEmpCount : null,
      minEmpCount: this.newFeeType.minEmpCount ? this.newFeeType.minEmpCount : null,
      // isNewlyAddedFeeType:this.newFeeType.id ? false : true
    };
    if (type === 'ADD' && !this.newFeeType.id) {
      this.newlyAddedFeeTypeArr.push(newFeeObj);
    } else if (type === 'UPDATE') {
      if (this.newFeeType.id) {
        const index = this.feeData.findIndex(ele => ele.id === this.newFeeType.id);
        this.feeData.splice(index, 1);
        this.feeData.splice(index, 0, newFeeObj);
      } else {
        const index = this.newlyAddedFeeTypeArr.findIndex(ele => ele.feeType.name === this.newFeeType.name);
        this.newlyAddedFeeTypeArr.splice(index, 1);
        this.newlyAddedFeeTypeArr.splice(index, 0, newFeeObj);
      }

    }
    this.toastr.success('Fee Details Updated Successfully', 'Success');

    // array.splice(1,0, 'pink');

    this.resetFeeType();
    this.displayAddFeeTypePanel = false;
    // this.feeData.push(newFeeObj);

  }
  editFeeType(rowIndex, item) {
    this.showUpdateButton = true;
    if (item) {
      this.displayAddFeeTypePanel = true;
      this.newFeeType = {
        feeAmount: item.applicableFee,
        name: item.feeType && item.feeType.name ? item.feeType.name : '',
        maxEmpCount: item.maxEmpCount ? item.maxEmpCount : null,
        minEmpCount: item.minEmpCount ? item.minEmpCount : null,
        id: item.id ? item.id : null

      };

    }

  }

  deleteFeeType(rowIndex, arr) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Delete',
      key: 'confirmDelete',
      accept: () => {
        arr.splice(rowIndex, 1);
        this.toastr.success('Fee Details Updated Successfully', 'Success');
      },
      reject: () => {
      }
    });

  }
  feeTypeCancel() {
    this.displayAddFeeTypePanel = false;
  }
  goBackToList() {
    this.router.navigate(['../../manage-visa/created-visas'], { relativeTo: this.route });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
